import React from "react";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import FitScreenIcon from "@mui/icons-material/FitScreen";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

type CertificateToolbarProps = {
  zoom: number;
  onZoomChange: (zoom: number) => void;
  onFit: () => void;
};

const PRESETS = [0.5, 0.75, 1];

function CertificateToolbar({ zoom, onZoomChange, onFit }: CertificateToolbarProps) {
  const rounded = Math.round(zoom * 100);

  return (
    <div className="certificate-toolbar" data-no-print="true">
      <button type="button" onClick={() => onZoomChange(Math.max(0.35, zoom - 0.1))} title="Zoom out">
        <ZoomOutIcon sx={{ fontSize: 16 }} />
      </button>
      <button type="button" onClick={() => onZoomChange(Math.min(1.6, zoom + 0.1))} title="Zoom in">
        <ZoomInIcon sx={{ fontSize: 16 }} />
      </button>
      <button type="button" onClick={onFit} title="Fit to screen">
        <FitScreenIcon sx={{ fontSize: 16 }} /> Fit
      </button>
      {PRESETS.map((value) => (
        <button
          key={value}
          type="button"
          className={Math.abs(zoom - value) < 0.02 ? "is-active" : ""}
          onClick={() => onZoomChange(value)}
        >
          {Math.round(value * 100)}%
        </button>
      ))}
      <button type="button" onClick={() => onZoomChange(1)} title="Reset view">
        <RestartAltIcon sx={{ fontSize: 16 }} /> Reset View
      </button>
      <span className="text-xs font-semibold text-slate-500">{rounded}%</span>
    </div>
  );
}

export default CertificateToolbar;
